// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--9PuCB","input":"styles-module--input--11uvv","pencil":"styles-module--pencil--fFLCJ"};